import { SIZES } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function SizeMatrix({ values, onChange, testIdPrefix = "size" }) {
  // values: { "36": 0, "37": 0, ... }
  return (
    <div className="grid grid-cols-5 sm:grid-cols-10 gap-2">
      {SIZES.map((s) => (
        <div key={s} className="flex flex-col items-stretch min-w-0">
          <label className="text-[10px] font-mono uppercase tracking-widest text-[#6B5B4A] text-center mb-1">
            N° {s}
          </label>
          <Input
            type="number"
            min={0}
            inputMode="numeric"
            data-testid={`${testIdPrefix}-${s}`}
            value={values[s] ?? ""}
            onChange={(e) => onChange(s, e.target.value === "" ? "" : Math.max(0, parseInt(e.target.value) || 0))}
            className="zs-size-input min-w-0 px-1 text-center h-11 bg-[#EFE6D6] border-[#DCCFB8] focus-visible:ring-[#D97706] focus-visible:border-[#D97706]"
            placeholder="0"
          />
        </div>
      ))}
    </div>
  );
}
